module.exports = __webpack_public_path__ + "img/bgg2@3x.b21740df.png";